<template>
    <div class="centers-text">
        <div class="present">
            <a href="javascript:void(0);" @click="about">
                <img
                        style="max-width: 100%;"
                        v-if="course.caticon"
                        :src="course.caticon"
                >
                <img
                        style="max-width: 100%;"
                        src="@/assets/hometeacher/images/home-kurs-none.png"
                        v-else
                >

            </a>
            <img src="~@/assets/hometeacher/images/podarok.png" class="podarok">
            <img class="dific" :src="require(`@/assets/hometeacher/images/${difficlty}.png`)">
            <h4>
                <a href="javascript:void(0);" @click="about">{{ course.course }}</a></h4>
            <p>{{ $t('Age') }}: {{ ageText }}</p>
            <p v-if="course.lessonscount">{{ $t('Lessons') }}: {{ course.lessonscount }}</p>
            <p v-if="course.duration">{{ $t('Lesson_duration') }}: {{ course.duration }}</p>
            <p v-if="course.duration_course">{{ $t('Course_duration') }}: {{ course.duration_course }}</p>
            <div class="cennik">0 {{ $t('cur') }}&nbsp;&nbsp;&nbsp;<span><s
                    v-if="course.price">{{ course.price }} {{ $t('cur') }}</s></span>
            </div>
        </div>
    </div>
</template>

<script>
    import numeral from 'numeral';
    import courseApi from "../../../data/CourseApi";

    export default {
        name: "StudyProductCourseItem",
        props: {
            title: String,
            course: {
                type: Object,
            },
            number: {
                type: [Number, String],
            },
            lastItem: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            ageText() {
                if (this.course.ages && this.course.ages.length > 0) {
                    let ages = []
                    for (let age of this.course.ages) {
                        ages.push(courseApi.getAgeName(age.idage))
                    }
                    return ages.join(", ")
                }
                return courseApi.getAllAgeNames();
            },

            languageText() {
                if (this.course.idlanguage) return courseApi.getLanguageName(this.course.idlanguage)
                return "-";
            },

            difficlty() {
                if (this.course.difficulty) return courseApi.getDifficultyName(this.course.difficulty).toLowerCase()
                return "easy";
            },
        },

        methods: {
            about() {
                this.$emit('about', this.course)
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        },
        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            }
        }
    }
</script>

<style>
    .present {
        width: 220px;
        height: 469px;
        border: 1px solid #d7e1e5;
        float: left;
        margin-right: -1px;
        padding: 20px;
        overflow: hidden;
        margin-bottom: 10px;
        position: relative;
    }

    .present img {
        border-radius: 10px;
    }

    .podarok {
        margin-left: 95px;
        margin-top: -285px;
    }

    .dific {
        margin-top: -30px;
    }

    .present h4 {
        font-family: "Manrope Bold";
        font-size: 18px;
        color: #262239;
        line-height: 1;
        margin-top: -9px;
        margin-bottom: 12px;
    }

    .present h4 a {
        color: #262239;
    }

    .present p {
        font-family: "Manrope Book";
        color: #4f4d5c;
        font-size: 14px;
        line-height: 1;
        margin-bottom: 10px;
    }

    .cennik {
        font-family: "Manrope Bold";
        font-size: 20px;
        color: #262239;
        position: absolute;
        bottom: 20px;
    }

    .cennik span {
        color: #4f4d5c;
        font-size: 16px;
        font-family: "Manrope Light";
        font-weight: bold;
    }

    @media (max-width: 1199px) {
        .cennik {
            position: inherit;
        }
    }

    @media (max-width: 1000px) {
        .present {
            float: none;
            margin: auto;
            width: 270px;
            height: 450px;
            text-align: left;
            box-shadow: 2px 2px 9px rgb(0 0 0 / 20%);
            border-radius: 10px;
        }

        .podarok {
            margin-left: 145px;
        }

        .cennik {
            position: absolute;
        }

    }
</style>
